export const SHOW_MODAL = "[ADMIN] SHOW_MODAL";
export const HIDE_MODAL = "[ADMIN] HIDE_MODAL";
export const SUBMIT_START = "[ADMIN] SUBMIT_START";
export const SUBMIT_ERROR = "[ADMIN] SUBMIT_ERROR";
export const UPDATE_MODAL_DATA = "[ADMIN] UPDATE_MODAL_DATA";

export const showModal = (type, data) => {
    return {
        type: SHOW_MODAL,
        payload: {
            type,
            data,
        }
    };
};

export const hideModal = () => {
    return {
        type: HIDE_MODAL,
    };
};

export const submitStart = () => {
    return {
        type: SUBMIT_START,
    };
};

